<template>
  <div>
    <button
      data-sense="sense_loan_online_widget"
      onclick="SENSE.loanMe()"
      :class="buttonClass"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
import * as CryptoJS from 'crypto-js'
import moment from 'moment'

export default {
  name: 'SenseCreditWidget',
  props: {
    args: {
      type: Object,
      require: true,
      default: () => ({}),
    },
    apiUrl: {
      type: String,
      require: false,
      default: () => '',
    },
    debug: {
      type: Boolean,
      require: false,
      default: () => false,
    },
    buttonText: {
      type: String,
      require: false,
      default: () => 'Кредит від Sense Банк',
    },
    buttonClass: {
      type: String,
      require: false,
      default: () => '',
    },
  },
  data: () => {
    return {
      login: '',
      frameSecretKey: '',
      defaultArgs: {
        partnerId: process.env.VUE_APP_SENSE_PARTNER_ID,
        shopId: Number(process.env.VUE_APP_SENSE_SHOP_ID),
        invoiceDate: moment().format('yyyy-MM-DD'),
        initialPaymentAmount: '0',
        redirectUrl: 'https://apptown.com.ua/thankyou',
      },
    }
  },
  beforeMount() {
    this.login = process.env.VUE_APP_SENSE_LOGIN || ''
    this.frameSecretKey = process.env.VUE_APP_SENSE_FRAME_SECRET_KEY || ''
  },
  computed: {
    widgetArgs() {
      return { ...this.defaultArgs, ...this.args }
    },
    apiScriptSrc() {
      const apiUrl = this.apiUrl || process.env.VUE_APP_SENSE_API_URL || ''
      return `${apiUrl}/api/external/easy-start.js?partnerId=${this.defaultArgs.partnerId}`
    },
    joined() {
      const _args = {
        login: this.login,
        frameSecretKey: this.frameSecretKey,
        ...this.widgetArgs,
      }
      return this.jsonValues(_args)
    },
    token() {
      return CryptoJS.SHA512(this.joined).toString(CryptoJS.enc.Hex)
    },
  },
  mounted() {
    const script = document.createElement('script')
    script.setAttribute('src', this.apiScriptSrc)
    script.setAttribute(
      'onerror',
      `alert(
        'Помилка завантаження. Перезавантажте сторінку через декілька хвилин.'
      )`
    )
    document.head.appendChild(script)

    window.SENSE = window.SENSE || {}
    window.SENSE_CLIENT = {
      token: this.token,
      version: 2,
      data: this.widgetArgs,
    }

    if (this.debug) {
      window.SENSE_CLIENT.signTemplate = this.joined
    }
  },
  methods: {
    isSet(val) {
      return val !== null && val !== undefined
    },
    jsonValues(dto) {
      const values = []
      const keys = [
        'login',
        'frameSecretKey',
        'clientPhone',
        'clientMail',
        'clientFirstName',
        'clientLastName',
        'clientMiddleName',
        'partnerId',
        'subProduct',
        'shopId',
        'gracePeriod',
        'initialPaymentAmount',
      ]
      const merchandiseKeys = ['code', 'name', 'quantity']
      keys.forEach((k) => {
        if (this.isSet(dto[k])) {
          values.push(dto[k])
        }
      })
      if (dto.merchandises) {
        dto.merchandises.forEach((m) => {
          merchandiseKeys.forEach((k) => {
            if (this.isSet(m[k])) {
              values.push(m[k])
            }
          })
        })
      }
      return values.join(':')
    },
  },
}
</script>

<style>
[id^='credit_close_sense']:after {
  color: #000 !important;
}
</style>
